import React from 'react';

const ContactUs = () => {
  return (
    <React.Fragment>
      {/* <!-- =========================
        Contact from Section
    ============================== --> */}
      <section id="contact-us">
        <div class="container">
          <div class="row">
            <div class="col-12 p0">
              <div class="page-location">
                <ul>
                  <li>
                    <a href="#">
                      Home<span class="divider">/</span>
                    </a>
                  </li>
                  <li>
                    <a class="page-location-active" href="#">
                      Contact Us
                      <span class="divider">/</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="contact-us-content">
            <div class="row">
              <div class="col-md-12">
                <div id="map"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-9 col-xl-9">
                <div class="contact-from">
                  <div class="contact-description">
                    <h4 class="contact-description-title">
                      Tell us about yourself
                    </h4>
                    <p class="contact-description-content">
                      Your email address will not be published. Required fields
                      are marked *
                    </p>
                  </div>
                  <form>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputEmail1" class="col-form-label">
                          Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="inputEmail1"
                          placeholder="Name"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4" class="col-form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          id="inputEmail4"
                          placeholder="Email"
                        />
                      </div>
                      <div class="form-group col-md-12">
                        <label
                          for="exampleFormControlTextarea1"
                          class="col-form-label"
                        >
                          Your Message
                        </label>
                        <textarea
                          class="form-control"
                          id="exampleFormControlTextarea1"
                        ></textarea>
                      </div>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary wd-contact-btn"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 col-xl-3">
                <div class="contact-address-area">
                  <h4 class="contact-address-title">Address</h4>
                  <p class="contact-address-content">
                    Your email address will not be published. Required fields
                    are marked *
                  </p>
                  <div class="contact-address">
                    <div class="media radius-icon-area">
                      <div class="radius-icon">
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                      </div>
                      <div class="media-body radius-content">
                        93 Worth St, New York, NY New york, saskaton
                      </div>
                    </div>
                    <div class="media radius-icon-area">
                      <div class="radius-icon">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                      </div>
                      <div class="media-body radius-content">
                        <p>
                          <a href="tel:+321123456">+321 123 456</a>
                        </p>
                        <p>
                          <a href="tel:+321123456">+321 123 456</a>
                        </p>
                      </div>
                    </div>
                    <div class="media radius-icon-area">
                      <div class="radius-icon">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </div>
                      <div class="media-body radius-content">
                        <p>
                          <a href="mailto:info@info.com">info@themeim.com</a>
                        </p>
                        <p>
                          <a href="mailto:badhon@gmail.com">
                            support@themeim.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- =========================
        Subscribe Section
    ============================== --> */}
      <section id="subscribe">
        <div class="container">
          {/* <!-- <div class="col-md-1"></div> --> */}
          <div class="row subscribe-body">
            <div class="col-12 col-md-12 col-lg-5">
              <h4 class="subscribe-title">Sign up for the latest updates</h4>
            </div>
            <div class="col-12 col-md-9 col-lg-5">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Text input with segmented button dropdown"
                />
              </div>
            </div>
            <div class="col-12 col-md-3 col-lg-2">
              <button
                type="button"
                class="btn btn-primary wd-shop-btn subscribe-btn"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ContactUs;
